import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { HeaderNav } from '../components/HeaderNav';
import { Footer } from '../components/Footer';
import { ArticleCard } from '../components/ArticleCard';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const categoryConfig = {
  features: {
    title: 'Features',
    description: 'In-depth stories exploring the intersection of brands and creators',
    category: 'features'
  },
  interviews: {
    title: 'Interviews',
    description: 'Conversations with industry leaders, creators, and innovators',
    category: 'interviews'
  },
  brands: {
    title: 'Brands',
    description: 'Stories about brands shaping the creator economy',
    category: 'brands'
  },
  creators: {
    title: 'Creators',
    description: 'Spotlights on the creators defining modern media',
    category: 'creators'
  }
};

export default function CategoryPage() {
  const location = useLocation();
  const category = location.pathname.split('/')[1]; // Extract category from path
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  const config = categoryConfig[category] || {
    title: category,
    description: `Browse ${category} articles`,
    category: category
  };

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/api/articles`, {
          params: {
            status: 'published',
            category: config.category,
            pageSize: 50
          }
        });
        setArticles(response.data);
      } catch (error) {
        console.error('Error fetching articles:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [category, config.category]);

  return (
    <>
      <Helmet>
        <title>{config.title} · B&B Magazine</title>
        <meta name="description" content={config.description} />
      </Helmet>

      <HeaderNav />

      <main className="min-h-screen bg-background">
        <div className="container max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Header */}
          <div className="mb-12 text-center">
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
              {config.title}
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {config.description}
            </p>
          </div>

          {/* Articles Grid */}
          {loading ? (
            <div className="text-center py-20">
              <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
            </div>
          ) : articles.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-muted-foreground text-lg">No articles found in this category yet.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}
